
const digest = '2a6569df1ce7f4c9543440a084ab5e2718b5295ad5acba5aa973d00ef1dce3ae';
const classes = {"addressWrapper":"_addressWrapper_qzfw4_1"};
const css = `._addressWrapper_qzfw4_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  